import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import {
  FacebookLeadgenFormsQuery,
  FacebookLeadgenFormsQueryVariables
} from './__generated__/FacebookLeadgenFormsQuery';

const FACEBOOK_LEADGEN_FORMS_QUERY = gql`
  query FacebookLeadgenFormsQuery(
    $search: String
    $includeDeprecated: Boolean
    $publisherIds: [ID!]
    $campaignIds: [ID!]
    $facebookPageIds: [ID!]
    $first: Int
    $last: Int
    $before: String
    $after: String
  ) {
    facebookLeadgenForms(
      search: $search
      includeDeprecated: $includeDeprecated
      publisherIds: $publisherIds
      campaignIds: $campaignIds
      facebookPageIds: $facebookPageIds
      first: $first
      last: $last
      before: $before
      after: $after
    ) {
      totalCount
      pageInfo {
        endCursor
        startCursor
      }
      edges {
        node {
          id
          name
          externalId
          encodedFacebookLeadgenFormSetId
          createdAt
          discardedAt
          leadsCount
          leadsCountUpdatedAt
          facebookPage {
            id
            name
          }
          article {
            id
            title
            campaign {
              id
            }
          }
        }
      }
    }
  }
`;

export const useFacebookLeadgenFormsLazyQuery = () => {
  return useLazyQuery<FacebookLeadgenFormsQuery, FacebookLeadgenFormsQueryVariables>(FACEBOOK_LEADGEN_FORMS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
